import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

import {
  media,
  buttonCSS,
  DeprecatedGrid as Grid,
} from '@simplywallst/ui-core';
import type { ButtonProps } from '@simplywallst/ui-core';

export const BannerWrapper = styled(Grid)`
  position: relative;
  background-color: ${({ theme }) => theme.color.phantom};
  padding: ${({ theme }) => theme.x2spacePx}px;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
`;

export const ImageWrapper = styled(Grid)`
  ${media.smDown`
    display: none;
  `};
`;

export const NewPortfolioLink = styled(RouterLink)<ButtonProps>`
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  ${buttonCSS}
`;
